import { render } from "./RNav.vue?vue&type=template&id=4e3672c9"
import script from "./RNav.vue?vue&type=script&lang=js"
export * from "./RNav.vue?vue&type=script&lang=js"

import "./RNav.vue?vue&type=style&index=0&id=4e3672c9&lang=css"
script.render = render

export default script